import styles from "./PendingSuspensionItem.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";

/**
 *
 * Displays the information of an incident in the pending suspension section. Clicking on the incident number will take the user to the incident details page. Clicking on the Suspend Button opens the Suspend User modal window.
 *
 */

export function PendingSuspensionItem({
  index,
  IncidentDetails,
  onSuspendClick,
}) {
  const shortNumber = IncidentDetails.id.substring(0, 8) + "...";
  return (
    <div
      className={classNames(styles.container, index % 2 !== 0 && styles.gray)}
    >
      {/* This link breaks in storybook */}
      <Link to={`/security/incident/${IncidentDetails.id}`}>
        <div className={classNames(styles.gridItem, styles.link)}>
          {shortNumber}
        </div>
      </Link>
      <div className={styles.gridItem}>{IncidentDetails.status}</div>
      <div className={styles.gridItem}>{IncidentDetails.problemType}</div>
      <div className={styles.gridItem}>{IncidentDetails.severity}</div>
      <Link to={`/security/ibo/${IncidentDetails.complaintAgainst.iboNumber}`}>
        <div className={classNames(styles.gridItem, styles.link)}>
          {IncidentDetails.complaintAgainst.iboNumber}
        </div>
      </Link>
      <div className={styles.gridItem}>{IncidentDetails.caseOwner}</div>
      <div className={(styles.gridItem, styles.buttonDiv)}>
        <button className={styles.button} onClick={onSuspendClick}>
          Suspend
        </button>
      </div>
    </div>
  );
}

PendingSuspensionItem.propTypes = {
  index: PropTypes.number,
  IncidentDetails: PropTypes.object,
  onClick: PropTypes.func,
  onIboClick: PropTypes.func,
  onSuspendClick: PropTypes.func,
};
